import {useMutation, UseMutationResult} from '@tanstack/react-query';
import useTrackedMutation, {
    UseTrackedMutationResult,
} from 'hooks/useTrackedMutation/index-deprecated';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {request} from 'utils/request';

export type UseDeleteEmailSuccessResponse =
    Api.Response.Success<Api.Response.Template.SuccessBasicMessage>;

export type UseDeleteEmailErrorResponse = Api.Response.Failure<'message'>;

export type UseDeleteEmailProps = {
    mid: string;
};

export const useDeleteEmail = (): UseMutationResult<
    UseDeleteEmailSuccessResponse,
    UseDeleteEmailErrorResponse,
    UseDeleteEmailProps
> => {
    const locale = useLocale();

    return useMutation(({mid}) =>
        request({
            formData: {},
            locale,
            method: 'POST',
            uri: `/api/profile/email-settings/email/${mid}/delete/`,
        }),
    );
};

export type UseSendConfirmationSuccessResponse =
    Api.Response.Success<Api.Response.Template.SuccessBasicMessage>;

export type UseSendConfirmationErrorResponse = Api.Response.Failure<'message'>;

export type UseSendConfirmationProps = {
    email_address: string;
};

export const useSendConfirmation = (): UseMutationResult<
    UseSendConfirmationSuccessResponse,
    UseSendConfirmationErrorResponse,
    UseSendConfirmationProps
> => {
    const locale = useLocale();

    return useMutation(({email_address}) =>
        request({
            formData: {email_address},
            locale,
            method: 'POST',
            uri: '/api/profile/email-settings/confirmation-email-link/create/',
        }),
    );
};

export type UseSetPrimarySuccessResponse =
    Api.Response.Success<Api.Response.Template.SuccessBasicMessage>;

export type UseSetPrimaryErrorResponse = Api.Response.Failure<'message'>;

export type UseSetPrimaryProps = {
    email: string;
};

export const useSetPrimary = (): UseMutationResult<
    UseSetPrimarySuccessResponse,
    UseSetPrimaryErrorResponse,
    UseSetPrimaryProps
> => {
    const locale = useLocale();

    return useMutation(({email}) =>
        request({
            formData: {email},
            locale,
            method: 'POST',
            uri: '/api/profile/email-settings/primary-email/update/',
        }),
    );
};

export type UseAddNewEmailSuccessResponse =
    Api.Response.Success<Api.Response.Template.SuccessBasicMessage>;

export type UseAddNewEmailErrorResponse = Api.Response.Failure<'message'>;

export type UseAddNewEmailProps = {
    address: string;
};

export const useAddNewEmailLink = (): UseMutationResult<
    UseAddNewEmailSuccessResponse,
    UseAddNewEmailErrorResponse,
    UseAddNewEmailProps
> => {
    const locale = useLocale();

    return useMutation(({address}) =>
        request({
            formData: {address},
            locale,
            method: 'POST',
            uri: '/api/profile/email-settings/email/create/',
        }),
    );
};

export type UseChangeCompanyEmailSuccessResponse =
    Api.Response.Success<Api.Response.Template.SuccessBasicMessage>;

export type UseChangeCompanyEmailErrorResponse =
    Api.Response.Failure<'message'>;

export type UseChangeCompanyEmailProps = {
    email: string;
    employee: string;
};

export const useChangeCompanyEmail = (): UseTrackedMutationResult<
    UseChangeCompanyEmailSuccessResponse,
    UseChangeCompanyEmailErrorResponse,
    UseChangeCompanyEmailProps
> => {
    const locale = useLocale();

    return useTrackedMutation<
        UseChangeCompanyEmailSuccessResponse,
        UseChangeCompanyEmailErrorResponse,
        UseChangeCompanyEmailProps
    >((formData) =>
        request({
            formData,
            locale,
            method: 'POST',
            uri: '/api/profile/email-settings/company-email/update/',
        }),
    );
};
